import React from "react";
import { Card, Typography } from "antd";

const PrivacyPage = () => (
  <div className="policy-container">
    <Card>
      <Typography.Title level={2}>Privacy Policy</Typography.Title>

      <Typography.Paragraph>
        Effective Date: <strong>November 15, 2025</strong>
      </Typography.Paragraph>

      <Typography.Paragraph>
        Finllie Water ("we", "our") is committed to protecting
        your privacy according to Indian Data Protection laws.
      </Typography.Paragraph>

      <Typography.Title level={4}>1. Information We Collect</Typography.Title>
      <Typography.Paragraph>
        - Name, email, phone number, address<br />
        - Orders & payment details (tokenized)<br />
        - Device info, IP, cookies<br />
      </Typography.Paragraph>

      <Typography.Title level={4}>2. How We Use Your Data</Typography.Title>
      <Typography.Paragraph>
        - Order processing<br />
        - Delivery updates<br />
        - Customer support<br />
        - Fraud prevention<br />
        - Marketing (only with consent)<br />
      </Typography.Paragraph>

      <Typography.Title level={4}>3. Sharing of Data</Typography.Title>
      <Typography.Paragraph>
        We share data with payment gateways, delivery partners, and support
        partners only. We never sell your data.
      </Typography.Paragraph>

      <Typography.Title level={4}>4. Data Security</Typography.Title>
      <Typography.Paragraph>
        We use encryption, SSL, and secure servers to protect your data.
      </Typography.Paragraph>

      <Typography.Title level={4}>5. Your Rights</Typography.Title>
      <Typography.Paragraph>
        You may request correction, deletion, or access to your data anytime.
      </Typography.Paragraph>

      {/* ⭐ NEW SECTION: Anti-Fraud / Order Validation */}
      <Typography.Title level={4}>6. Fraud Prevention & Order Validation</Typography.Title>
      <Typography.Paragraph>
        Finllie reserves the right to verify, cancel, or reject any order in
        cases of suspected fraud, payment manipulation, price tampering,
        unauthorized access, technical misuse, or any activity that violates
        the integrity of our platform.
      </Typography.Paragraph>

      <Typography.Paragraph>
        In the event of abnormal pricing, incorrect order value, or suspected
        hacking (including attempts to artificially reduce payable amounts),
        Finllie may hold, cancel, or deny delivery of the order and take
        further legal or technical action as needed. The customer agrees that
        Finllie’s decision in such situations is final and binding.
      </Typography.Paragraph>

      <Typography.Title level={4}>7. Contact</Typography.Title>
      <Typography.Paragraph>
        Email: finlliesales@gmail.com<br />
        Phone: +91 9945089397
      </Typography.Paragraph>
    </Card>
  </div>
);

export default PrivacyPage;
